<template>
    <div class="section">
        <h1 class="title">Settings</h1>
        <div class="columns">
            <div class="column is-one-fifth">
                <aside class="menu">
                    <p class="menu-label">General</p>
                    <ul class="menu-list">
                        <li>
                            <RouterLink @click="resetError" to="/settings/legs" active-class="is-active">Legs</RouterLink>
                        </li>
                        <li>
                            <RouterLink @click="resetError" to="/settings/emails" active-class="is-active">Emails</RouterLink>
                        </li>
                        <li>
                            <RouterLink @click="resetError" to="/settings/users" active-class="is-active">Users</RouterLink>
                        </li>
                    </ul>
                </aside>
            </div>
            <div class="column">
                <div v-if="error" class="notification is-danger">
                    {{ error }}
                </div>
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, provide } from 'vue';

export default {
    setup() {
        const error = ref(null);
        provide('error', error);

        const resetError = () => {
            error.value = null;
        };

        return {
            error,
            resetError
        }
    }
}
</script>